import type { ResponseDto } from '@app/api/dtos'
import type { CompetitorsDto } from '@app/api/routes/locationCompetitors/dtos'
import type { TranslationsCompetitorsDataSource } from '@app/types/dataSource/TranslationsCompetitorsDataSource'

export const getTranslationsCompetitorsDataFromResponse = (
  response?: ResponseDto<CompetitorsDto>
): TranslationsCompetitorsDataSource[] | undefined => {
  if (!response) return

  const rawData: CompetitorsDto[] | undefined = response?.results

  if (!rawData) return

  return rawData.map(dto => ({
    key: dto.id,
    network: dto?.network?.name ?? null,
    text: dto?.text ?? null
  }))
}
